
/* globals console, module, require */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
/* jscs:disable disallowDanglingUnderscores */
'use strict';

const jQuery = require('jquery'),
    Marionette = require('backbone.marionette'),
    _ = require('lodash'),
    //
    // Create = require('./create'),
    ProgramSummary = require('./programSummary'),
    templates = require('../utilities/handlebars').templates,
    EOL = null;

module.exports = Marionette.CollectionView.extend({
    attributes: {
        class: 'programs-summaries'
    },
    childView: ProgramSummary,
    childViewContainer: 'div[name=programsSummaries]',
    childViewEvents: {
        'select:program': 'onSelectProgram'
    },
    childViewOptions: undefined,
    events: {
        'click button': 'onClickButton'
    },
    tagName: 'div',
    template: templates.programsSummaries,
    //
    currentProgramIds: function () {
        // get the ids of all the programs that are visible
        const a = [];
        this.children.each(function (child) {
            if (!child.model.hidden) {
                a.push(child.model.id);
            }
        });
        return a;
    },
    filterPrograms: function (value) {
        // can't use viewFilter because we need the all the children and their text present
        // plus this way we only render the summaries once per fetch...
        const terms =  value ? value.split(' ') : [],
            regex = value ? new RegExp(terms.join('|'), 'ig') : null;
        let shown = 0;
        this.children.each(function (child) {
            let show = true,
                match;
            if (regex) {
                match = child.$el.text().toLowerCase().match(regex);
                show = match && _.uniq(match).length === terms.length; // uniq to exclude multiples of a term
            }
            if (show) {
                shown++;
            }
            child.$el[show ? 'show' : 'hide']();
            child.model.hidden = !show;
        });
        this.trigger('programs:filtered', shown);
    },
    focus: function (program) {
        // the program may not be focusable if, for example, the status has changed to verify
        if (this.children._indexByModel[program.cid]) {
            this.children._indexByModel[program.cid].focus();
        }
    },
    initialize: function () {
        this.childViewOptions = {
            popout: this.options.popout
        };
        this.templateContext = {
            dashboard: this.options.dashboard ? true : false
        };
        this.listenTo(this.collection, 'reset', _.bind(function () {
            if (this.options.show) {
                this.trigger('select:program', this.collection.get(this.options.show));
                this.options.show = null;
            }
        }, this));
    },
    onClickButton: function (event) {
        switch (event.currentTarget.dataset.action) {
            case 'add':
                this.trigger('create:program');
                break;
            default:
                break;
        }
        return false;
    },
    onSelectProgram: function (childView) {
        this.trigger('select:program', childView.model);
    }
});
